<template>
    <div class="grid grid-cols-12 gap-4">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'Row',
};
</script>
